import template from './cajas.html';
import abrirTemplate from './abrir.html';
import cerrarTemplate from './cerrar.html';
import { FormActions } from 'core/services/form';
import cajasI18NI18N from 'i18n/cajas/es.json';
import { rest } from 'core/api';
import config from 'config.json';
import { download } from 'core/util';
import { formatErrorMessage } from 'core/util';

export let CajasComponent = {
  templateUrl: template,
  selector: 'cajas',
  bindings: {
    translations: '='
  },
  controller: CajasCtrl,
  controllerAs: 'vm'
};

const commonsI18N = [
  'Elemento borrado correctamente'
];
export const translationKeys = Object.keys(cajasI18NI18N).concat(commonsI18N);

CajasCtrl.$inject = [
  'BasicFactory', '$ngRedux', '$state', '$filter', '$stateParams', '$scope', '$compile', '$timeout', 'ngNotify', 'Filter', 'AuthorizationService', 'localStorageService', 'ConfirmationModal', 'CustomModal', '$resource', 'HeadersUtil'
];

function CajasCtrl(BasicFactory, $ngRedux, $state, $filter, $stateParams, $scope, $compile, $timeout, ngNotify, Filter,
  AuthorizationService, localStorageService, ConfirmationModal, CustomModal, $resource, HeadersUtil) {

  var defaultColumnOrder = ['nombre', 'numero', 'puntoEmision.descripcion', 'sesionActual.estado.value', 'estado.value'];
  //var staticFilter = Filter.path('activo').eq(true);
  BasicFactory.setup('cajas');

  const estadoQuery = Filter.path('tipo.codigo').eq('estado_caja');
  const estadoUrl = encodeURI('valores?filter=' + JSON.stringify(estadoQuery));

  const estadoSesionQuery = Filter.path('tipo.codigo').eq('estado_sesion_caja');
  const estadoSesionUrl = encodeURI('valores?filter=' + JSON.stringify(estadoSesionQuery));

  this.options = {
    //staticFilter,
    resource: 'cajas',
    hideHeader: true,
    hasOptions: true,
    title: this.translations['Listado de cajas'],
    factory: BasicFactory,
    defaultColumnOrder: defaultColumnOrder,
    createdRow: function(row, data, dataIndex) {
      let caja = localStorageService.get('caja');
      if (caja && data.id === caja.id) {
        $(row).addClass('warning');
        localStorageService.set('caja', { id: data.id, numero: data.numero, nombre: data.nombre, sesionActual: data.sesionActual, puntoEmision: data.puntoEmision });
      }
    },
    columns: [
      { data: 'id', title: 'Id' },
      { data: 'nombre', title: this.translations['Nombre'] },
      { data: 'numero', title: this.translations['Número'] },
      { data: 'puntoEmision.descripcion', title: this.translations['Punto de Emisión'], defaultContent: '<i>No establecido - <b>Verificar</b></i>' },
      {
        data: 'sesionActual.estado.value',
        title: this.translations['Sesión Caja'],
        type: 'combo',
        filterUrl: estadoSesionUrl,
        idField: 'value',
        textField: 'name',
        keyData: 'data',
        render: function(data, type, row) {
          return row.sesionActual ? row.sesionActual.estado.name : '<i>Sin sesión</i>';
        }
      },
      {
        data: 'estado.value',
        title: this.translations['Estado'],
        type: 'combo',
        filterUrl: estadoUrl,
        idField: 'value',
        textField: 'name',
        keyData: 'data',
        render: function(data, type, row) {
          return row.estado ? row.estado.name : '<i>No establecido</i>';
        }
      }
    ],
    defaultOrderColumn: 0,
    defaultOrderDir: 'desc',
    onEdit: onEdit.bind(this),
    onRemove: onRemove.bind(this),
    onView: onView.bind(this),
    canEditCondition: AuthorizationService.hasPermission.bind(this, 'update_cajas'),
    canGetReporte: canGetReporte.bind(this),
    canGetReporteApertura: canGetReporteApertura.bind(this),
    canRemoveCondition: AuthorizationService.hasPermission.bind(this, 'delete_cajas'),
    canAsignar: canAsignar.bind(this),
    canForzarAsignar: canForzarAsignar.bind(this),
    extraRowOptions: [
      {
        templateToRender: '<button class="btn-row-datatable btn-row-datatable-extra btn btn-primary btn-dt" uib-tooltip="' + this.translations['Asignar caja al equipo'] + '" ng-show="options.canAsignar(rowsData[<%= dataId %>])" ng-click="asignarCaja(<%= dataId %>)"> <span class="glyph-icon icon-thumb-tack" style="top: -8px;"></span></button>',
        functionName: 'asignarCaja',
        functionDef: (itemId) => {
          let self = this;
          CustomModal.open({
            title: 'Asignar',
            id: itemId,
            message: '¿Desea asignar la caja a esta estación?',
            ok: function() {
              let caja = localStorageService.get('caja');
              let payload = {};
              if (caja) {
                payload.cajaActualId = caja.id;
              }
              $ngRedux.dispatch(rest.actions.asignarCaja({ id: itemId }, {
                body: JSON.stringify(payload)
              }, (err, data) => {
                if (!err && data.estado.value == 'Asignada') {
                  localStorageService.set('caja', { id: data.id, numero: data.numero, nombre: data.nombre, sesionActual: data.sesionActual, puntoEmision: data.puntoEmision });
                  ngNotify.set(self.translations['Asignada Correctamente'], 'success');
                  self.options.reloadData();
                } else if (err) {
                  ngNotify.set(err.message, 'warn');
                }
              }));
            }
          });
        }
      },
      {
        templateToRender: '<button class="btn-row-datatable btn-row-datatable-extra btn btn-danger btn-dt" uib-tooltip="' + this.translations['Forzar asignación de caja al equipo'] + '" ng-show="options.canForzarAsignar(rowsData[<%= dataId %>])" ng-click="asignarForzadoCaja(rowsData[<%= dataId %>])"> <span class="glyph-icon icon-thumb-tack" style="top: -8px;"></span></button>',
        functionName: 'asignarForzadoCaja',
        functionDef: (data) => {
          let self = this;
          // let caja = localStorageService.get('caja');
          // if (caja && caja.sesionActual && caja.sesionActual.estado.value === 'Abierta') {
          //   ngNotify.set(self.translations['Primero debe cerrar la caja asignada al equipo'], 'warn');
          //   return;
          // }

          CustomModal.open({
            title: 'Forzar Asignación',
            message: '¿Desea forzar la asignación de la caja a esta estación?',
            ok: function() {
              localStorageService.set('caja', { id: data.id, numero: data.numero, nombre: data.nombre, sesionActual: data.sesionActual, puntoEmision: data.puntoEmision });
              ngNotify.set(self.translations['Asignada Correctamente'], 'success');
              self.options.reloadData();
            }
          });
        }
      },
      {
        templateToRender: '<button class="btn-row-datatable btn-row-datatable-extra btn btn-primary btn-dt" uib-tooltip="' + this.translations['Reporte Transacciones'] + '" ng-show="options.canGetReporte(rowsData[<%= dataId %>])" ng-click="reporteSesionCaja(<%= dataId %>)"> <span class="glyph-icon icon-list-ol" style="top: -8px;"></span></button>',
        functionName: 'reporteSesionCaja',
        functionDef: (itemId) => {
          download('cajas', itemId, 'reportes-sesiones-caja', config, $resource, HeadersUtil, { tipo: 'pdf' });
        }
      },
      {
        templateToRender: '<button class="btn-row-datatable btn-row-datatable-extra btn btn-primary btn-dt" uib-tooltip="' + this.translations['Reporte Apertura'] + '" ng-show="options.canGetReporteApertura(rowsData[<%= dataId %>])" ng-click="reporteAperturaCaja(<%= dataId %>)"> <span class="glyph-icon icon-folder-open-o" style="top: -8px;"></span></button>',
        functionName: 'reporteAperturaCaja',
        functionDef: (itemId) => {
          download('cajas', itemId, 'reporte-apertura-caja', config, $resource, HeadersUtil, { tipo: 'pdf' });
        }
      },
      {
        templateToRender: '<button class="btn-row-datatable btn-row-datatable-extra btn btn-primary btn-dt" uib-tooltip="' + this.translations['Lista Sesiones Caja'] + '" ng-show="true" ng-click="listaSesiones(<%= dataId %>)"> <span class="glyph-icon icon-align-left" style="top: -8px;"></span></button>',
        functionName: 'listaSesiones',
        functionDef: (itemId) => {
          $state.go('home.cajas.uid.sesiones-cajas.list', { uid: itemId });
        }
      }
    ]
  };

  function canForzarAsignar(data) {
    let caja = localStorageService.get('caja');
    if (caja && caja.id === data.id) {
      return false;
    }
    return (data.estado.value === 'Asignada') && AuthorizationService.hasPermission('update_cajas');
  }

  function canAsignar(data) {
    let caja = localStorageService.get('caja');
    if (caja && caja.id === data.id) {
      return false;
    }
    return (data.estado.value === 'No Asignada') && AuthorizationService.hasPermission('update_cajas');
  }

  function canGetReporte(data) {
    return (data.sesionActual) && AuthorizationService.hasPermission('index_cajas');
  }

  function canGetReporteApertura(data) {
    return (data.sesionActual && data.sesionActual.estado.value === 'Abierta') && AuthorizationService.hasPermission('index_cajas');
  }

  this.handleStatus = handleStatus.bind(this);
  this.abrirCaja = abrirCaja.bind(this);
  this.cerrarCaja = cerrarCaja.bind(this);
  this.mapStateToThis = mapStateToThis.bind(this);
  this.gotoForm = gotoForm.bind(this);
  this.puedeAbrir = puedeAbrir.bind(this);
  this.puedeCerrar = puedeCerrar.bind(this);
  this.downloadReportResumenFinanciero = downloadReportResumenFinanciero.bind(this);
  this.downloadReportArqueoCaja = downloadReportArqueoCaja.bind(this);
  this.reportesCierreNotify = reportesCierreNotify.bind(this);

  const unsubscribe = $ngRedux.connect(this.mapStateToThis, FormActions)(this);

  this.$onDestroy = () => {
    this.form();
    this.ordenesPendientesSesionActual = null;
    this.facturasPendientesCobroSesionActual = null;
    $ngRedux.dispatch(rest.actions.ordenesPendientesSesionActual.reset());
    $ngRedux.dispatch(rest.actions.facturasPendientesCobroSesionActual.reset());
    unsubscribe();
  };

  this.$onInit = () => {
    this.reportOptions = {
      title: this.translations['Listado de cajas']
    };
    this.form();

    fetchOrdenesPendientes();
    fetchFacturasPendientesCobro();

    if ($stateParams.cid) {
      this.reportesCierreNotify($stateParams.cid);
    }
  };

  /**
   * Si existe una caja abierta, trae las ordenes pendientes (no facturadas ni procesadas con giftcard)
   * durante el periodo de la sesion actual de la caja.
   */
  function fetchOrdenesPendientes() {
    let caja = localStorageService.get('caja');
    if (!caja || !caja.sesionActual || caja.sesionActual.estado.value === 'Cerrada') {
      return;
    }
    $ngRedux.dispatch(rest.actions.ordenesPendientesSesionActual({cajaActualId: caja.id}));
  }

  /**
   * Si existe una caja abierta, trae las facturas pendientes de cobro
   * durante el periodo de la sesion actual de la caja.
   */
  function fetchFacturasPendientesCobro() {
    let caja = localStorageService.get('caja');
    if (!caja || !caja.sesionActual || caja.sesionActual.estado.value === 'Cerrada') {
      return;
    }
    $ngRedux.dispatch(rest.actions.facturasPendientesCobroSesionActual({cajaActualId: caja.id}));
  }



  function downloadReportResumenFinanciero(cajaId) {
    download('cajas', cajaId, 'reporte-resumen-financiero', config, $resource, HeadersUtil, { tipo: 'pdf' });
  }

  function downloadReportArqueoCaja(cajaId) {
    download('cajas', cajaId, 'reporte-arqueo-caja', config, $resource, HeadersUtil, { tipo: 'pdf' });
  }

  function reportesCierreNotify(cajaId) {
    let html = $compile(`<div>${this.translations['Cerrada Correctamente']}<br/><a class="go-in-notify btn btn-danger" ng-click="vm.downloadReportResumenFinanciero(${cajaId})">${this.translations['Resumen Financiero']}</a><a class="go-in-notify btn btn-danger" ng-click="vm.downloadReportArqueoCaja(${cajaId})">${this.translations['Arqueo de Caja']}</a></div>`)($scope);

    ngNotify.set('<div class="notificacion-cierre"></div>', {
      position: 'bottom',
      duration: 9000,
      type: 'success',
      sticky: true,
      button: true,
      html: true
    });

    $timeout(function() {
      $('.notificacion-cierre').empty();
      $('.notificacion-cierre').append(html);
    }, 400);
  }

  function mapStateToThis(state) {
    if (state.currentUser) {
      this.user = state.currentUser.data;
    }

    if (state.ordenesPendientesSesionActual.data
      && state.ordenesPendientesSesionActual.data.data
      && state.ordenesPendientesSesionActual.data.data.length > 0
      && !(this.ordenesPendientesSesionActual && this.ordenesPendientesSesionActual.length > 0)) {

      this.ordenesPendientesSesionActual = state.ordenesPendientesSesionActual.data.data;
    }

    if (state.facturasPendientesCobroSesionActual.data
      && state.facturasPendientesCobroSesionActual.data.data
      && state.facturasPendientesCobroSesionActual.data.data.length > 0
      && !(this.facturasPendientesCobroSesionActual && this.facturasPendientesCobroSesionActual.length > 0)) {

      this.facturasPendientesCobroSesionActual = state.facturasPendientesCobroSesionActual.data.data.map(f => {
        f.importe = $filter('currency')(f.importe, 'Gs.', 0);
        return f;
      });
    }

    this.handleStatus(state);
    return {
      form: state.form
    };
  }

  function handleStatus(state) {
    if (state.form.removed) {
      ngNotify.set(this.translations['Elemento borrado correctamente'], 'success');
      this.options.reloadData();
      this.form();
    }

    if (state.form.error) {
      ngNotify.set(formatErrorMessage(state.form.error.message), { type: 'error', html: true });
    }
  }

  function gotoForm() {
    $state.go('home.cajas.new');
  }

  this.localModel = {
    payload: {}
  };

  function puedeAbrir() {
    let caja = localStorageService.get('caja');
    return !caja || !caja.sesionActual || caja.sesionActual.estado.value === 'Cerrada';
  }

  function puedeCerrar() {
    let caja = localStorageService.get('caja');
    return caja && caja.sesionActual && caja.sesionActual.estado.value === 'Abierta';
  }

  function abrirCaja() {
    let caja = localStorageService.get('caja');
    if (!caja) {
      ngNotify.set(this.translations['Debe asignar una caja al equipo'], 'warn');
      return;
    } else if (caja.sesionActual && caja.sesionActual.estado.value === 'Abierta') {
      ngNotify.set(this.translations['La caja ya está abierta'], 'warn');
      return;
    }

    let self = this;
    this.localModel.payload = {};
    CustomModal.open({
      title: 'Abrir Caja',
      caja: caja,
      templateUrl: abrirTemplate,
      usuario: this.user,
      fecha: moment(new Date()).format('DD/MM/YYYY hh:mm'),
      payload: this.localModel.payload,
      ok: function() {
        $ngRedux.dispatch(rest.actions.abrirCaja({ id: caja.id }, {
          body: JSON.stringify(self.localModel.payload)
        }, (err, data) => {
          if (!err && data.sesionActual.estado.value === 'Abierta') {
            ngNotify.set(self.translations['Abierta Correctamente'], 'success');
            localStorageService.set('caja', { id: data.id, numero: data.numero, nombre: data.nombre, sesionActual: data.sesionActual, puntoEmision: data.puntoEmision });
            self.options.reloadData();
          } else if (err) {
            ngNotify.set(err.message, 'warn');
          }
        }));
      }
    });
  }

  function cerrarCaja() {
    let caja = localStorageService.get('caja');
    if (!caja || !caja.sesionActual || caja.sesionActual.estado.value === 'Cerrada') {
      ngNotify.set(this.translations['La caja no está abierta'], 'warn');
      return;
    }
    this.localModel.payload = {};
    CustomModal.open({
      title: 'Cerrar Caja',
      caja: caja,
      templateUrl: cerrarTemplate,
      usuario: this.user,
      fecha: moment(caja.sesionActual.fechaInicio).format('DD/MM/YYYY hh:mm'),
      payload: this.localModel.payload,
      ordenesPendientes: this.ordenesPendientesSesionActual,
      facturasPendientes: this.facturasPendientesCobroSesionActual,
      ok: function() {
        $state.go('home.cajas.cerrar');
      }
    });
  }

  function onEdit(itemId) {
    $state.go('home.cajas.uid.edit', { uid: itemId });
  }

  function onRemove(itemId) {
    this.remove('cajas', itemId);
  }

  function onView(itemId) {
    $state.go('home.cajas.uid.view', { uid: itemId });
  }
}



// WEBPACK FOOTER //
// ./src/components/cajas/list/cajas.component.js